import { useMutation } from '@tanstack/react-query';

import { resolve } from 'api/resolve';

import { useProjectsApi } from '../projects/projects-api';

export type UpdateProjectNodeParams = {
  projectId: string;
  nodeId: string;
  templateNodeId: string;
  properties: Record<string, unknown>;
  proposalId?: string;
};

export function useUpdateProjectNode() {
  const { updateNode } = useProjectsApi();

  return useMutation({
    mutationFn: ({ projectId, nodeId, templateNodeId, properties, proposalId }: UpdateProjectNodeParams) => {
      return resolve(updateNode(projectId, nodeId, templateNodeId, properties, proposalId));
    }
  });
}
